import Helpers from "../../../Javascript/Helpers";
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

class ButtonNext {
    /**
     *
     * @param selector element link selector
     * @param options
     */
    constructor (selector, options) {
        this._element = document.querySelector(selector);
        this._options = Helpers.extend(ButtonNext.options, options);
    }

    init () {
        this._element.classList.add('show');
        this._element.addEventListener("click", (e) => {
            const top = document.querySelector(this._options.scrollTo).getBoundingClientRect().top + (Helpers.outerHeight(document.querySelector(this._options.scrollToOffsetElement)) * -1);
            e.preventDefault();

            window.scrollTo({top : top, left : 0, behavior : 'smooth'});
        });
    }

    /**
     * @param position
     * @see relation in frontend.js and call from ScrollMonitor
     */
    onScroll (position) {
        (position > 1) ? this._element.classList.add('hide') : this._element.classList.remove('hide');
    }
}

ButtonNext.options = {
    scrollTo : "main",
    scrollToOffsetElement : ".NavigationToggle",
    duration : 1000
};

export default ButtonNext;
